module.exports = __webpack_public_path__ + "web/img/grade2.a5e43a79.png";